/* eslint-disable react/sort-comp */
/* eslint-disable react/no-deprecated */
import React, { Component } from 'react';
import _ from 'lodash';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { Divider, List, ListItem, ListItemIcon, ListItemText } from '@material-ui/core';
import { ChevronRight } from '@material-ui/icons';
import { styles } from './Marketing.styles';
import 'rc-time-picker/assets/index.css';
import 'react-datepicker/dist/react-datepicker.css';
import { version } from '../../../package.json';
import { Title, Paper } from '../../components';
import * as actions from '../../actions/index';
import { marketing } from '../../constants/mainViewList';
import { checkAccess } from '../../utils/admins'
import {
  mainColor,
  GENERAL_DESIGN_ROUTE,
  WEB_DESIGN_ROUTE,
  MOBILE_DESIGN_ROUTE,
  FEDILITY_PROGRAM_ROUTE,
  CODE_PROMO_ROUTE,
  PUSH_NOTIF_ROUTE,
  ACTIVATION_ROUTE, DEEPLINK_ROUTE
} from '../../constants';

class Marketing extends Component {
  render() {
    const { classes, showHelpModal, sidebarCollapse, isAllShops, nbShops, mobileApp, branch } = this.props;
    const sections = _.filter(marketing, setting => {
      const { url } = setting;
      const urlArray = [GENERAL_DESIGN_ROUTE, WEB_DESIGN_ROUTE, MOBILE_DESIGN_ROUTE, FEDILITY_PROGRAM_ROUTE, ACTIVATION_ROUTE, DEEPLINK_ROUTE]
      if (!mobileApp.enabled) urlArray.push(PUSH_NOTIF_ROUTE)
      if (isAllShops || (nbShops === 1 && checkAccess('pages', 'marketing')))

        return (
          url === GENERAL_DESIGN_ROUTE ||
          url === WEB_DESIGN_ROUTE ||
          url === MOBILE_DESIGN_ROUTE ||
          url === FEDILITY_PROGRAM_ROUTE ||
          (url === CODE_PROMO_ROUTE && nbShops === 1) ||
          (url === PUSH_NOTIF_ROUTE && nbShops === 1) || url === ACTIVATION_ROUTE || (url === DEEPLINK_ROUTE && branch?.enabled)
        );
      return !urlArray.includes(url);
    });

    return (
      <div className='px-4 pb-4' >
        <Title title='Marketing' onClick={() => showHelpModal('design')} />
        <div
          className={`col-12 ${sidebarCollapse &&
            'col-lg-10'} flex-row justify-content-cenetr align-items-center px-0 `}
        >
          <div className='col-md-12 p-0'>
            <Paper>
              <List>
                {_.map(sections, (setting, index) => {
                  return (
                    <Link
                      key={index}
                      style={{ color: 'transparent' }}
                      to={{
                        pathname: `${setting.url}`,
                        state: { title: setting.text, subtitle: setting.description }
                      }}
                    >
                      <ListItem button className={classes.gutters} key={index}>
                        <ListItemIcon>{setting.icon}</ListItemIcon>
                        <ListItemText
                          style={{ color: mainColor.colorBlack }}
                          primary={setting.text}
                          secondary={setting.description}
                        />
                        <ChevronRight style={{ color: mainColor.colorBlack }} />
                      </ListItem>
                      {index <= sections.length - 2 && <Divider variant='inset' component='li' />}
                    </Link>
                  );
                })}
              </List>
            </Paper>
            <p className={classes.versionText}> Version: {version} </p>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps({ user, firebaseRealTime, sidebar }) {
  const { isAllShops, nbShops } = user;
  const { generalConfig } = firebaseRealTime;
  const { mobileApp = {}, branch = {} } = generalConfig;
  const { sidebarCollapse } = sidebar;
  return {
    mobileApp,
    sidebarCollapse,
    nbShops,
    isAllShops,
    branch
  };
}

export default connect(mapStateToProps, actions)(withStyles(styles)(withRouter(Marketing)));
